import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const PpServiceNr = {
	name: NAME,
	apiProvider,
	router,
};
